import { TabsContent } from '@/components/molecules';
import { Plans } from '../plans-section';

export const SubscriptionTab = () => {
  return (
    <TabsContent value="subscription">
      <Plans />
    </TabsContent>
  );
};
